import { Paper, Skeleton, Stack } from "@mui/material";

/** Placeholder that mirrors ViewInterfaceModal's body while the detail loads. */
const ViewInterfaceSkeleton = () => (
  <Stack spacing={2.5}>
    <Skeleton width={70} height={16} />
    <Skeleton variant="rounded" height={40} />
    <Skeleton variant="rounded" height={40} />

    <Paper variant="outlined">
      <Skeleton
        variant="rectangular"
        height={44}
        sx={{ borderBottom: "1px solid #0000001F" }}
      />
      <Stack spacing={1.5} sx={{ p: 1.5 }}>
        <Skeleton height={20} />
        {[0, 1, 2].map((row) => (
          <Skeleton key={row} variant="rounded" height={34} />
        ))}
      </Stack>
    </Paper>

    <Paper variant="outlined">
      <Skeleton
        variant="rectangular"
        height={44}
        sx={{ borderBottom: "1px solid #0000001F" }}
      />
      <Stack spacing={1.5} sx={{ p: 1.5 }}>
        {[0, 1].map((row) => (
          <Skeleton key={row} variant="rounded" height={34} />
        ))}
      </Stack>
    </Paper>
  </Stack>
);

export default ViewInterfaceSkeleton;
